import { render, staticRenderFns } from "./ScatterTable.vue?vue&type=template&id=2d0d83a4&"
import script from "./ScatterTable.vue?vue&type=script&lang=js&"
export * from "./ScatterTable.vue?vue&type=script&lang=js&"
import style0 from "./ScatterTable.vue?vue&type=style&index=0&id=2d0d83a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports